import { TextSelection } from 'prosemirror-state';
/*
 * 当粘贴到空段落内时，视为替换掉此段落而非注入内容到其中
 */
// cypress 暂时没法测试粘贴动作。
// 这里需要关注的几种 case：
// - 居中段落粘贴进空段落或全部选中的段落，应该得到居中段落
// - 标题粘贴进空段落或全部选中的段落，应该得到标题
// - 引用内的一整段原地剪切粘贴，应该没有变化
export const handlePaste = (view, _e, slice) => {
    var _a;
    const { dispatch, state: { doc, tr, selection }, } = view;
    const { $from, $to } = selection;
    if (selection instanceof TextSelection &&
        $from.parent === $to.parent &&
        $from.parent.isTextblock &&
        $to.pos - $from.pos === $from.parent.content.size &&
        ((_a = slice.content.firstChild) === null || _a === void 0 ? void 0 : _a.type.isTextblock)) {
        const $before = doc.resolve($from.pos - 1);
        const $after = doc.resolve($to.pos + 1);
        // 这里不用 NodeSelection 是因为它 undo 时会有痕迹
        dispatch(tr.setSelection(new TextSelection($before, $after)));
    }
    return false;
};
//# sourceMappingURL=callbacks.js.map